import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import transportIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getTransportA2Totals } from "../../../../../apis/Product/TransportA2Api";

const TransportA2Icon = () => (
  <img src={transportIcon} alt="Transport A2 Icon" width={76} height={76} />
);

const TransportA2Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState(null);

  useEffect(() => {
    if (productId) {
      getTransportA2Totals({
        productId,
        setTotals: setTotalProdItem,
      });
    }
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`transport-a2-category ${className || ""}`}
      leftBoxProps={{
        icon: <TransportA2Icon />,
        title: t("TRANSPORT_A2") || "Transport (A2)",
        description:
          t("TRANSPORT_A2_INTRO") ||
          "Transport to manufacturing site, including surplus materials and losses during transportation.",
        productId: productId,
        isSystemBoundary: false,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_32") || "Total for Flow 32",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalProdItem?.impact_totals || null,
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default TransportA2Header;
